import {
  Card,
  CardContent,
  type CardProps,
  Stack,
  Typography,
  type TypographyProps,
  styled,
  useTheme,
} from "@mui/material"
import { EvolutionStatChip, type IconUrl } from "@pharmupp/p3-front-commons"
import type { ReactNode } from "react"

export interface LoyaltyProgramCardProps {
  Icon: IconUrl
  evolution?: number | null
  title: ReactNode
  subtitle: ReactNode
  value: ReactNode
  slotProps?: {
    Title?: TypographyProps
    Subtitle?: TypographyProps
    Value?: TypographyProps
    Card?: CardProps
  }
}

export const LoyaltyProgramCard = ({
  Icon,
  evolution,
  title,
  subtitle,
  value,
  slotProps = {},
}: LoyaltyProgramCardProps) => {
  const { palette, typography } = useTheme()
  return (
    <CardStyled {...slotProps.Card}>
      <CardContentStyled>
        <TitleContainer>
          <Icon color={palette.tertiary.dark2} size={typography.pxToRem(30)} />
          <Stack>
            <Title {...slotProps.Title}>{title}</Title>
            <Subtitle {...slotProps.Subtitle}>{subtitle}</Subtitle>
          </Stack>
        </TitleContainer>
        <ValueContainer>
          <Value {...slotProps.Value}>{value}</Value>
          {evolution && (
            <EvolutionStatChip border={false} arrow={true} evol={evolution} />
          )}
        </ValueContainer>
      </CardContentStyled>
    </CardStyled>
  )
}

const CardStyled = styled(Card)({ flex: 1 })
const CardContentStyled = styled(CardContent)(({ theme }) => ({
  height: "100%",
  justifyContent: "space-between",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  padding: theme.spacing(3),
}))
const TitleContainer = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: theme.spacing(2.5),
  alignItems: "center",
}))
const ValueContainer = styled(Stack)({
  flexDirection: "row",
  justifyContent: "space-between",
})
const Value = styled(Typography)({ flex: 1, fontWeight: 600 })
Value.defaultProps = {
  variant: "20px",
}
const Title = styled(Typography)({})
Title.defaultProps = {
  variant: "16px",
}

const Subtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey.light,
}))
Subtitle.defaultProps = {
  variant: "12px",
}
